import { StyledButton } from '../../Atoms/Button/styles'
import { StyledInput } from '../../Atoms/Input/styles'
import { styled } from '../../Styles/stitches.config'

export const StyledGreenInputField = styled('div', {
    display: 'flex',
    position: 'relative',

    [`& ${StyledButton}`]: {
        br: '0 $1 $1 0',
        h: 'auto',
        overflow: 'unset',
        px: '$3',
        position: 'relative',
    },

    [`& ${StyledInput}`]: {
        bc: '$secondary500',
        fontWeight: 600,
        p: '$3',

        '&:hover, &:focus': {
            bc: '$secondary500',
        },

        '&:focus': {
            bgc: '$neutral100',

            '&::placeholder': {
                color: '$primary600',
                fontWeight: 400,
                textAlign: 'left',
            },
        },
    },

    variants: {
        showButton: {
            true: {
                [`& ${StyledButton}`]: {
                    '&:disabled': {
                        bgc: '$secondary300',
                        bc: '$secondary300',
                        color: '$neutral400',
                        opacity: 1,
                    },
                },

                [`& ${StyledInput}`]: {
                    borderRight: 'none',
                    br: '$1 0 0 $1',
                },
            },
            false: {
                [`& ${StyledButton}`]: {
                    '&:disabled': {
                        border: 0,
                        color: '$primary600',
                        overflow: 'hidden',
                        p: 0,
                        w: 0,
                    },
                },

                [`& ${StyledInput}`]: {
                    bgc: '$secondary500',

                    '&::placeholder': {
                        color: '$primary600',
                        fontSize: 18,
                        fontWeight: 600,
                        textAlign: 'center',
                    },
                },
            },
        },
    },

    defaultVariants: { showButton: false },
})

export const StyledTestAddress = styled('div', {
    w: '100%',

    '.dawa-autocomplete-suggestions': {
        bgc: '$white',
        borderBottom: '1px solid $neutral300',
        br: '$1',
        left: 0,
        m: 0,
        maxH: 250,
        overflowY: 'auto',
        p: 0,
        position: 'absolute',
        right: 0,
        textAlign: 'left',
        top: '100%',
        zIndex: '$dropdown',

        '.dawa-autocomplete-suggestion': {
            border: '1px solid $neutral300',
            borderBottomWidth: 0,
            color: '$black',
            cursor: 'pointer',
            listStyle: 'none',
            m: 0,
            p: '$2',

            '&:first-child': {
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit',
            },

            '&:last-child': {
                borderBottomLeftRadius: 'inherit',
                borderBottomRightRadius: 'inherit',
            },

            '&.dawa-selected, &:hover': {
                bgc: '$primary200',
                color: '$primary600',
                fontWeight: 600,
            },
        },
    },
})
